import clsx from 'clsx';

import { IWithContextProps, core, withContext } from '@tock/coretypes';
import { IconCrossSmall } from '@tock/icons';
import BaseComponent from '@tock/shared/components/BaseComponent';
import CreditCardBrandMapping from '@tock/shared/constants/CreditCardBrandMapping';
import CreditCardIcon from './CreditCardIcon';
import IconButton from '@tock/shared/components/buttons/IconButton';

interface Props {
  card: core.PaymentCard;
  disabled?: boolean;
  isSelected?: boolean;
  onSelect?(card: core.PaymentCard): void;
  onDelete(card: core.PaymentCard): void;
}

class CreditCard extends BaseComponent<Props & IWithContextProps> {
  handleDelete() {
    this.props.onDelete(this.props.card);
  }

  handleSelect() {
    if (this.props.disabled) {
      return;
    }
    if (this.props.onSelect) {
      this.props.onSelect(this.props.card);
    }
  }

  render() {
    const { card } = this.props;

    const existsInDictionary = card.brand in CreditCardBrandMapping;
    const cardBrand = existsInDictionary ? card.brand : 'Unknown';
    const { maskClass } = CreditCardBrandMapping[cardBrand];

    const className = clsx('B1', 'CreditCards-card', {
      'is-selected': this.props.isSelected,
      'is-disabled': this.props.disabled,
    });
    const numberClassName = clsx('CreditCards-number', maskClass);

    return (
      <div className={className} data-testid="credit-card-item">
        <CreditCardIcon brand={cardBrand} />

        <div className={numberClassName}>
          <span className="CreditCards-numberMask CreditCards-numberMaskOne">•••• •••••• •</span>
          <span className="CreditCards-numberMask CreditCards-numberMaskTwo">•••• •••• ••••</span>
          <span className="CreditCards-numberLastFour">{card.maskedNumber}</span>
        </div>

        <div className="CreditCards-cardActions">
          <IconButton
            IconComponent={IconCrossSmall}
            onClick={this.handleDelete}
            iconSize="large"
            variant="borderless"
            text="Delete"
            hideText
            disabled={!card.patronCanDelete}
          />
        </div>

        <div className="CreditCards-selectIconContainer">
          <i className="CreditCards-selectIcon icon icon-arrow-right" />
        </div>
      </div>
    );
  }
}

export default withContext(CreditCard);
